import React, { ReactNode } from "react";
import NavigationBar from "./components/layout/NavigationBar";
import Header from "./components/layout/Header";
import { useLocation } from "react-router-dom";
import { useNavbar } from "./context/NavBarContext";
import NavigationBarHamberger from "./components/layout/NavigationBarHamberger";
import ReactGA from "react-ga4";

ReactGA.initialize(`${process.env.REACT_APP_GA4}`);
console.log("start ga4 tracking");

interface AppPropsType {
  children: ReactNode;
}

function App({ children }: AppPropsType) {
  let location = useLocation();
  const { isOpen } = useNavbar();

  return (
    <div className="content-container font-noto-sans-thai relative">
      <div className="w-full col-span-2 relative hidden xl:block">
        <NavigationBar />
      </div>
      {isOpen && (
        <div className="w-full block absolute z-10 left-0 top-0 xl:hidden">
          <NavigationBarHamberger />
        </div>
      )}
      {location.pathname.split("/")[1] !== "map" ? (
        <div className="w-full h-auto col-span-12 xl:col-span-10 pr-4 pl-4 pt-8">
          <Header />
          {children}
        </div>
      ) : (
        <div className="h-full w-full col-span-12 xl:col-span-10">
          {children}
        </div>
      )}
    </div>
  );
}

export default App;
